import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { NgForm } from '@angular/forms';
import { ChangeDetectionStrategy } from '@angular/compiler';
import { RestProviderService } from '../../services/rest-provider/rest-provider.service'
import { LocalStorageService } from '../../services/local-storage-service/local-storage.service'
import { TranslationsProviderService } from '../../services/translations-provider/translations-provider.service'
import { environment } from '../../../environments/environment'
import { RequestModel } from '../../models/request/request-model';
import { SemToken } from '../../models/oauth/semToken'

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone:false
})
export class LoginComponent implements OnInit, AfterViewInit {
  showAlertMessage: boolean;
  disabled: boolean = false;
  showGreenAlert: boolean;
  alertMessage: any;
  showOTP: boolean;
  username: string = "";
  otp: string = "";
  password: string = "";
  showRegistration: boolean = false;
  showPasswordReset: boolean = false;
  showActivation: boolean = false;
  showNewPassword: boolean = false;

  newPasswordResetInProgress: boolean = false;
  newPasswordResetSuccess: boolean = false;

  public loginViewName: string = "";
  public forgotPasswordMail: string = "";
  public newPasswordRepeat: string = "";
  public newPassword: string = "";
  private pwResetToken: string = "";
  public pwChangeDone: boolean = false;

  registrationPassword: string = "";
  registrationPasswordRepeat: string = "";
  registrationName: string = "";
  registrationEmail: string = "";
  successMessage: string = "";
  activationToken: string = "";

  registrationSubmitted: boolean = false;
  regInProcess: boolean = false;
  regSuccess: boolean = false;
  activationInProgress: boolean = false;
  activationSuccess: boolean = false;
  showLoginBtn: boolean = false;
  resetInProcess: boolean = false;
  resetSuccess: boolean = false;

  googleLoginEnabled:boolean = true;

  environment = environment;

  @ViewChild('registrationForm') protected registrationForm: NgForm | undefined;
  @ViewChild('passwordResetForm') protected passwordResetForm: NgForm | undefined;

  clear() {
    this.registrationPassword = "";
    this.registrationPasswordRepeat = "";
    this.registrationName = "";
    this.registrationEmail = "";
    this.activationToken = "";
    this.showActivation = false
    this.showLoginBtn = false;
    this.forgotPasswordMail = "";

    this.activationInProgress = false;
    this.activationSuccess = false;
    this.regInProcess = false;
    this.regSuccess = false;
    this.registrationSubmitted = false;
    this.showPasswordReset = false;
    this.showRegistration = false;
    this.showAlertMessage = false;
    this.regInProcess = false;
    this.alertMessage = "";
    this.successMessage = "";
    this.showNewPassword = false;
  }

  constructor(public cd:ChangeDetectorRef, private rp: RestProviderService, private httpClient: HttpClient, private router: Router, private localStorageService: LocalStorageService,
     private translationsService: TranslationsProviderService, private route: ActivatedRoute) { }

  ngAfterViewInit(): void {

        // @ts-ignore
        google.accounts.id.initialize({
          client_id: environment.googleClientId,
          callback: this.googleLogin.bind(this),
          auto_select: false,
          cancel_on_tap_outside: true,
          use_fedcm_for_prompt: true,
        });
        // @ts-ignore
        google.accounts.id.renderButton(
          // @ts-ignore
          document.getElementById("google-button"),
          { theme: "outline", size: "large", width: "324px" }
        );
  }

  async googleLogin(response: any) {
      this.httpClient.post(`${environment.wgProfileHost}/api/enroll/google-auth`, {
      "credential": response.credential,
    },).subscribe({
      next: response => {
        this.handleLoginResponse(response);
      },
      error: err => {
        this.disabled = false;
      }
    });
  }

  handleLoginResponse(response: Object) {
    if (response != null) {

      let warning = response["warning"];
      if (warning !== null && warning !== undefined && warning === true) {

        this.showAlertMessage = true;
        this.alertMessage = response["warningMsg"];

      } else {

        if (response["otpRequired"] === true) {
          this.showOTP = true;
          this.otp = "";
        } else {
          this.showOTP = false;
          this.procesResponse(response);
        }

      }

      this.disabled = false;
    }
  }

  ngOnInit(): void {
    this.loginViewName = "userLogin";
    let homepage = this.localStorageService.get("homepage_url");

    this.pwResetToken = this.route.snapshot.queryParams['token'];
    if (this.pwResetToken !== null && this.pwResetToken !== undefined && this.pwResetToken.length > 0) {
      this.loginViewName = "passwordReset";
      this.showNewPassword = true;
    }

    this.activationToken = this.route.snapshot.queryParams['actoken'];
    if (this.activationToken !== null && this.activationToken !== undefined && this.activationToken.length > 0) {
      this.showActivation = true;
      this.processActivation();
    }

    if (homepage) {
      window.location.href = homepage;
    }
  }

  sendMailForgotPassword() {
    this.showGreenAlert = false;
    this.disabled = true;

    this.alertMessage = "";
    this.showAlertMessage = false;
    this.successMessage = "";
    this.resetSuccess = false;

    let url = "/api/account/password/reset/" + this.forgotPasswordMail;

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    };

    this.resetInProcess = true;

    this.httpClient
      .get(environment.wgProfileHost + url, options)
      .subscribe(response => {


        if (response) {

          if (response["Error"]) {
            this.showGreenAlert = false;
            this.alertMessage = response["Message"];
            this.showAlertMessage = true;
          } else {
            this.showGreenAlert = true;
            this.forgotPasswordMail = "";
            this.successMessage = response["Message"];
            this.resetSuccess = true;
          }

        }
        this.disabled = false;
        this.resetInProcess = false;
      },
        error => {
          this.resetInProcess = false;
          this.resetSuccess = false;
          this.disabled = false;
          this.showAlertMessage = true;
          this.alertMessage = "Prosimo, pravilno izpolnite vaš e-poštni račun";
        });
  }

  processActivation() {
    this.activationInProgress = true;
    this.alertMessage = "";
    this.showAlertMessage = false;



    let obj = new RequestModel;
    obj.data = {
      "RegToken": this.activationToken
    };

    obj.url = "api/account/actoken";

    this.rp.getDataPOST(obj)
      .subscribe(response => {

        this.successMessage = "Aktivacija uspešna, prosimo prijavite se.";
        this.activationInProgress = false;
        this.activationSuccess = true;

      }, (error: any) => {

        try {
          if (error.error) {
            this.showAlertMessage = true;
            this.alertMessage = error.error;
            this.regInProcess = false;
            this.activationInProgress = false;
            this.showLoginBtn = true;
            return;
          }
        } catch (e) { }


        this.showAlertMessage = true;
        this.alertMessage = "Napaka pri aktivaciji, prosimo poskusite ponovno";
        this.regInProcess = false;
        this.activationInProgress = false;
      });


  }

  loginClick(otpLogin: boolean = false) {

    this.alertMessage = "";
    this.showAlertMessage = false;
    this.disabled = true;
    this.showGreenAlert = false;
    let body = new URLSearchParams();
    let url = "";

    if (environment.usernameAlwaysToLower) {
        this.username = this.username.toLowerCase().trim();
    }

    body.set('username', this.username);
    body.set('grant_type', 'password');

    if (otpLogin) {
      body.set('otp', this.otp);
      url = "/oauth/otptoken";
    } else {
      body.set('password', this.password);
      url = "/oauth/token";
    }

    //TODO: Update language from environment
    let options = {
      headers:  new HttpHeaders({
        'Content-Type': "application/x-www-form-urlencoded",
        'Accept-Language': environment.language,
      })
      };

    this.httpClient
      .post(environment.wgProfileHost + url, body.toString(), options)
      .subscribe(response => {

        if (response != null) {

          let warning = response["warning"];
          if (warning !== null && warning !== undefined && warning === true) {

            this.showAlertMessage = true;
            this.alertMessage = response["warningMsg"];

          } else {

            if (response["otpRequired"] === true) {
              this.showOTP = true;
              this.otp = "";
            } else {
              this.showOTP = false;
              this.procesResponse(response);
            }

          }

          this.disabled = false;
        }
      },
        error => {
          this.disabled = false;
          this.showAlertMessage = true;
          this.alertMessage = "Napaka pri prijavi, prosimo poskusite ponovno";
        });

  }

  sendPasswordResetValues() {

    this.showAlertMessage = false;
    this.alertMessage = "";
    this.successMessage = "";

    this.registrationSubmitted = true;
    if (this.passwordResetForm?.valid) {

      if (this.registrationPassword != this.registrationPasswordRepeat) {
        this.showAlertMessage = true;
        this.alertMessage = "Gesli se ne ujemata";
        return;
      }

      this.pwChangeDone = false;
      this.showGreenAlert = false;
      this.disabled = true;

      this.newPasswordResetInProgress = true;

      let url = "/api/account/password/reset/token";

      let options = {
        headers:  new HttpHeaders({
          'Content-Type': "application/json",
          'Accept-Language': environment.language,
        })
      };

      let body = {
        NewPassword: this.registrationPassword,
        NewPasswordRepeat: this.registrationPasswordRepeat,
        Token: this.pwResetToken
      }



      this.httpClient
        .post(environment.wgProfileHost + url, JSON.stringify(body), options)
        .subscribe(response => {


          if (response) {

            if (response["Error"]) {
              this.showGreenAlert = false;
              this.newPasswordResetSuccess = false;
              this.showAlertMessage = true;
              this.alertMessage = response["Message"];
            } else {
              this.showGreenAlert = true;
              this.newPassword = "";
              this.newPasswordRepeat = "";
              this.newPasswordResetSuccess = true;
              this.successMessage = response["Message"];
            }

          }
          this.disabled = false;
          this.newPasswordResetInProgress = false;
        },
          error => {
            this.newPasswordResetInProgress = false;
            this.disabled = false;
            this.showAlertMessage = true;
            this.alertMessage = "Prišlo je do napake pri ponastavljanju gesla. Prosimo, kontaktirajte nas.";
          });
    }

  }

  procesResponse(response) {
    let languageCode = this.localStorageService.get("language");
    if (languageCode == null) {
      languageCode = environment.language.toUpperCase();
    }

    localStorage.clear();

    this.localStorageService.add("language", languageCode);

    let token = new SemToken;
    token.accessToken = response["access_token"];
    token.created = new Date();

    let expires = new Date();
    expires.setHours(expires.getHours() + 24);
    token.expires = expires;

    this.localStorageService.add("token", JSON.stringify(token));

    let userData = jwtDecode(token.accessToken);

    this.localStorageService.add("user", userData["userState"]);//response["user"]);

    //this.rp.setCookie("_galis_access_token", response["access_token"], 1, "/");
    this.rp.currentUser = JSON.parse(userData["userState"]);

    let transObj = new RequestModel;
    transObj.data = {
      "LanguageCode": languageCode
    };

    transObj.url = "api/translation/all";

    this.rp.getDataPOST(transObj).subscribe(data => {

      let translations = data["Translations"];
      this.translationsService.translations = translations;
      this.localStorageService.add("translations", JSON.stringify(translations));

      if (typeof response["dashboard_url"] != "undefined" && response["dashboard_url"]) {
        this.localStorageService.add("homepage_url", response["dashboard_url"]);
        window.location.href = response["dashboard_url"];
      } else {
        this.localStorageService.add("homepage_url", "cms/dashboard");
        window.location.href = "cms/dashboard";
      }

    }, error => {
      this.disabled = false;
    });
  }

  registrationClick() {

    this.registrationSubmitted = true;
    this.alertMessage = "";
    this.showAlertMessage = false;

    if (this.registrationForm?.valid) {

      if (this.registrationPassword != this.registrationPasswordRepeat) {
        this.showAlertMessage = true;
        this.alertMessage = "Gesli se ne ujemata";
        return;
      }

      let obj = new RequestModel;
      obj.data = {
        "FullName": this.registrationName,
        "EMail": this.registrationEmail,
        "Password": this.registrationPassword,
        "PasswordRepeat": this.registrationPasswordRepeat
      };

      obj.url = "api/enroll/post";

      this.regInProcess = true;

      this.rp.getDataPOST(obj)
        .subscribe(response => {

          this.successMessage = "Registracija uspešna, prosimo preverite e-pošto in sledite navodilom.";
          this.regInProcess = false;
          this.regSuccess = true;

        }, (error: any) => {

          try {
            if (error.error) {
              this.showAlertMessage = true;
              this.alertMessage = error.error;
              this.regInProcess = false;
              return;
            }
          } catch (e) { }


          this.showAlertMessage = true;
          this.alertMessage = "Napaka pri registraciji, prosimo poskusite ponovno"
          this.regInProcess = false;
        });

    }
  }

}
